import React, { useRef } from 'react'
import {
  Box,
  Button,
  Flex,
  useColorModeValue,
  useDisclosure,
  useToast
} from '@chakra-ui/react'
import { AddIcon } from '@chakra-ui/icons'
import { DragDropContext } from '@hello-pangea/dnd'
import Header from '../Header'
import PageTransition from '../components/PageTransition'
import { useTaskManagement } from './utils'
import TaskColumn from './TaskColumn'
import AddEditTaskModal from './AddEditTaskModal'

const BrainstormTasks: React.FC = () => {
  const toast = useToast()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const initialFocusRef = useRef(null)

  const cardBg = useColorModeValue('white', 'gray.700')
  const cardBorder = useColorModeValue('gray.200', 'gray.600')
  const columnBgColor = useColorModeValue('gray.50', 'gray.800')

  const {
    taskState,
    newTask,
    setNewTask,
    editingTask,
    setEditingTask,
    isEditing,
    handleAddTask,
    handleEditTask,
    deleteTask,
    openEditModal,
    openAddModal,
    handleDragEnd
  } = useTaskManagement(toast)

  return (
    <>
      <Header title="Chrysalis: Hatching Insights" subtitle="Brainstorm Tasks" />
      <PageTransition>
        <Box p={4}>
          <Flex justifyContent="flex-end" mb={4}>
            <Button
              leftIcon={<AddIcon />}
              colorScheme="teal"
              onClick={() => openAddModal(onOpen)}
            >
              Add Task
            </Button>
          </Flex>

          <DragDropContext onDragEnd={handleDragEnd}>
            <Flex
              justifyContent="space-between"
              alignItems="flex-start"
              flexWrap="wrap"
              gap={4}
            >
              {taskState.columnOrder.map(columnId => {
                const column = taskState.columns[columnId]
                const tasks = column.taskIds.map(taskId => taskState.tasks[taskId])

                return (
                  <TaskColumn
                    cardBg={cardBg}
                    cardBorder={cardBorder}
                    column={column}
                    columnBgColor={columnBgColor}
                    key={column.id}
                    onDelete={deleteTask}
                    onEdit={(task) => openEditModal(task, onOpen)}
                    tasks={tasks}
                  />
                )
              })}
            </Flex>
          </DragDropContext>
        </Box>
      </PageTransition>

      <AddEditTaskModal
        editingTask={editingTask}
        handleAddTask={() => handleAddTask(onClose)}
        handleEditTask={() => handleEditTask(onClose)}
        initialFocusRef={initialFocusRef}
        isEditing={isEditing}
        isOpen={isOpen}
        newTask={newTask}
        onClose={onClose}
        setEditingTask={setEditingTask}
        setNewTask={setNewTask}
      />
    </>
  )
}

export default BrainstormTasks
